import { IOAuthCredentialTypeInfo } from '../../../ts/ServerApi/types/IOAuthCredential';
import { IOAuthCredentialDisplayStrings, IOAuthCredentialsService } from '../../../ts/services/OAuthCredentialsService';
import { ServiceLocator } from '../../../app/ServiceLocator';

function filter(credentialTypeInfo: IOAuthCredentialTypeInfo) {
  const oAuthCredentialsService: IOAuthCredentialsService = ServiceLocator.get<IOAuthCredentialsService>('OAuthCredentialsService');
  const displayStrings: IOAuthCredentialDisplayStrings = oAuthCredentialsService.getDisplayStrings(credentialTypeInfo.type);
  return displayStrings && displayStrings.displayName;
}

export const CredentialTypeFilter = {
  filter
};